import httpClient from "@/utils/httpClient";

export const getTodaysAttendence = async () => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const response = await httpClient.get(`/daily-tracker/attendance?date=${today}`);
    
    return {
      success: response.success,
      data: response.data || [],
      error: response.error
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};
export const getUpcomingLeaves = async () => {
  try {
    const response = await httpClient.get('/leaves/upcoming');
    
    // Transform data to match dashboard expectations
    const transformedData = response.data?.map(leave => ({
      id: leave.leave_id,
      name: leave.employee_name,
      type: leave.leave_type,
      startDate: leave.start_date,
      endDate: leave.end_date,
      avatar: leave.employee_name.split(' ').map(n => n[0]).join('')
    })) || [];

    return {
      success: response.success,
      data: transformedData,
      error: response.error
    };
  } catch (error) {
    console.error('getUpcomingLeaves error:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};

export const getDashboardStats = async () => {
  try {
    const response = await httpClient.get('/dashboard/stats');

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getDashboardStats error:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};

export const getDailyTrackerCounts = async () => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const response = await httpClient.get(`/daily-tracker/counts?date=${today}`);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error) {
    console.error('getDailyTrackerCounts error:', error);
    return {
      success: false,
      data: null,
      error: error.response?.data?.error || { message: error.message }
    };
  }
};
 